<template>
  <div class="add-emails">
    <b-form-input
      @keyup.enter="addEmail"
      v-model="emails"
      @update="validateEmail(emails)"
      type="email"
      required
      :placeholder="type.charAt(0).toUpperCase() + type.slice(1) + ':'"
      size="sm"
      autocomplete="off"
    ></b-form-input>
    <span v-if="!isEmails" class="add-emails__red-alert"
      >Please, enter an email address.</span
    >

    <div v-if="thereIsEmails" class="add-emails__copy-to-content">
      <template v-for="(email, index) in copy">
        <span
          v-bind:key="email + index"
          class="add-emails__copy-to-content--email box-shadow"
        >
          {{ email }}
          <button
            class="add-emails__copy-to-content--close-email"
            v-bind:key="index"
            @click="deleteEmail(index)"
            type="button"
            aria-label="Close email"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddEmails",
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      emails: null,
      isEmails: true,
      thereIsEmails: false,
      copy: [],
      quoteById: null,
      splittedEmails: [],
      errorEmails: []
    };
  },
  watch: {
    copy() {
      if (this.type == "to") {
        this.$emit("input", this.copy);
      }
    }
  },
  async mounted() {
    this.quoteById = this.$store.getters["quotes/quote/showQuoteById"];
    if (this.type == "to") {
      this.emails = this.quoteById.message.client_email;
    } else {
      if (this.quoteById.message[this.type]) {
        this.emails = this.quoteById.message[this.type];
      }
    }
    this.addEmail();
  },
  methods: {
    validateEmail(emails) {
      this.isEmails = this.validateEmailText(emails);
    },
    addEmail() {
      if (this.emails !== "" && this.emails !== null) {
        this.splittedEmails = this.emails.split(/[,\s]/);
        if (this.emails.includes(" ")) {
          let emailsAux = this.emails.replaceAll(" ", "");
          this.emails = emailsAux;
        }
      }
      this.splittedEmails.forEach(element => {
        let verifyEmail = this.validateEmailText(element);
        if (verifyEmail) {
          if (this.copy.indexOf(element) === -1) {
            this.copy.push(element);
            this.emails = null;
            this.thereIsEmails = true;
          }
        } else {
          if (element !== "" && element !== null) {
            this.errorEmails.push(element);
          }
        }
      });
      if (this.quoteById.message[this.type] != this.copy.join(",")) {
        this.updateMessage();
      }
      this.emails = "";
      for (let i = 0; i < this.errorEmails.length; i++) {
        if (this.errorEmails.length === i + 1) {
          this.emails += this.errorEmails[i];
          break;
        }
        this.emails += this.errorEmails[i] + ", ";
        this.isEmails = true;
      }
      this.splittedEmails = [];
      this.errorEmails = [];
    },
    deleteEmail(index) {
      this.copy.splice(index, 1);
      if (this.copy.length == 0) {
        this.thereIsEmails = false;
      }
      if (this.quoteById.message[this.type] != this.copy.join(",")) {
        this.updateMessage();
      }
    },
    validateEmailText(emails) {
      if (emails != null && emails != undefined && emails != "") {
        if (
          /^.*[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\.[a-zA-Z0-9-]+)*$/.test(
            emails
          )
        ) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    },
    async updateMessage() {
      let info = {};
      info.messageId = this.quoteById.message.id;
      info.body = {};
      if (this.type == "bcc") {
        info.body.bcc = this.copy.join(",");
      } else if (this.type == "cc") {
        info.body.cc = this.copy.join(",");
      } else if (this.type == "to") {
        info.body.client_email = this.copy.join(",");
      }
      await this.$store.dispatch("quotes/updateMessage", info);
      this.quoteById = await this.$store.getters["quotes/quote/showQuoteById"];
    }
  }
};
</script>

<style lang="scss" scoped>
.add-emails {
  width: 100%;
  margin: $margin-most-used 0px;

  &__red-alert {
    width: 100% !important;
    color: red;
    font-size: 12px;
    margin-top: $margin-most-used / 2;
    @include flex-wrap(flex-start);
  }

  &__copy-to-content {
    text-align: left;
    margin-top: $margin-most-used / 2;

    &--email {
      display: inline-block;
      margin-top: $margin-most-used/3;
      background-color: rgba(253, 143, 59, 0.2);
      border-radius: 30px;
      padding: 3px 7px;
      font-size: 13px;
      margin-right: 10px;
    }

    &--close-email {
      @include close-button(rgba(253, 143, 59, 0.2));
      font-size: 12px;
    }
  }
}
</style>
